var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 26.34C33.49 26.34 34.86 24.97 34.86 23.28C34.86 21.59 33.49 20.22 31.8 20.22C30.11 20.22 28.74 21.59 28.74 23.28C28.74 24.97 30.11 26.34 31.8 26.34Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5H40.5V31.65H45V4.5C45 2.01 42.99 0 40.5 0H4.5C2.01 0 0 2.01 0 4.5V58.5C0 60.99 2.01 63 4.5 63H22.5V58.5H4.5V4.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.04 35.37H60.54V9C60.54 6.51 58.53 4.5 56.04 4.5H49.29V9H56.04V35.37Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53.76C47.4853 53.76 49.5 51.7453 49.5 49.26C49.5 46.7747 47.4853 44.76 45 44.76C42.5147 44.76 40.5 46.7747 40.5 49.26C40.5 51.7453 42.5147 53.76 45 53.76Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.49 48.33C59.64 41.1 52.77 36.24 45 36C37.23 36.24 30.33 41.1 27.51 48.33L27 49.5L27.51 50.67C30.36 57.9 37.23 62.76 45 63C52.77 62.76 59.67 57.9 62.49 50.67L63 49.5L62.49 48.33ZM45 58.5C40.02 58.5 36 54.48 36 49.5C36 44.52 40.02 40.5 45 40.5C49.98 40.5 54 44.52 54 49.5C54 54.48 49.98 58.5 45 58.5Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessMonitoring);
export default __webpack_public_path__ + "static/media/ic-access-monitoring.ef773802cd0a2aaf4b68344c7e5ac35b.svg";
export { ForwardRef as ReactComponent };